import DownloadIcon from '@material-design-icons/svg/filled/download.svg?react';
import ExpandMoreIcon from '@material-design-icons/svg/filled/expand_more.svg?react';
import QrCodeIcon from '@material-design-icons/svg/filled/qr_code_2.svg?react';
import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { formatFileSize } from '../../utils/stringHelpers';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

interface ApkDownloadMenuProps {
  url: string;
  fileSize: number | null;
}

export function ApkDownloadMenu({ url, fileSize }: ApkDownloadMenuProps) {
  const [isQrOpen, setIsQrOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            aria-label="APK download options"
            className="inline-flex items-center gap-1 rounded bg-neutral-800/50 px-2 py-0.5 text-xs text-teal-400 transition-colors hover:text-teal-300"
            onClick={(event) => event.stopPropagation()}
          >
            <DownloadIcon className="size-3 fill-current" />
            <span>APK</span>
            {fileSize != null && (
              <span className="text-neutral-500">
                ({formatFileSize(fileSize)})
              </span>
            )}
            <ExpandMoreIcon className="size-3 fill-current" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="start"
          className="z-50 border-neutral-700 bg-neutral-900 text-neutral-200"
        >
          <DropdownMenuItem asChild>
            <a href={url} download>
              <DownloadIcon className="fill-current" />
              Download APK
            </a>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setIsQrOpen(true)}>
            <QrCodeIcon className="fill-current" />
            Show QR code
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={isQrOpen} onOpenChange={setIsQrOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader>
            <DialogTitle>Scan to download APK</DialogTitle>
            <DialogDescription>
              Scan this code with your phone to open the APK download link.
            </DialogDescription>
          </DialogHeader>
          <div className="mx-auto rounded-lg bg-white p-3">
            <QRCodeSVG
              value={url}
              size={256}
              marginSize={4}
              title="APK download link"
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
